import { gql } from 'urql';
import { PRODUCT } from '../client';

// Answers at once: the dispatch keeps its status and cancelRequestedAt is set
// until the provider confirms or refuses, which the courier dialog's poll reads.
export const CANCEL_PROVIDER_ROUTE = gql`
  mutation ${PRODUCT}CancelProviderRoute($input: CancelProviderRouteInput!) {
    cancelProviderRoute(input: $input) {
      route {
        id
        providerDispatch {
          status
          error
          cancelRequestedAt
          cancelable
          unmarkable
        }
      }
      userErrors {
        __typename
        ... on UserErrorInterface {
          message
        }
      }
    }
  }
`;
